import React from 'react';
import CrmTagsPage from '../components/CrmTagsPage';

const CrmTagsApp = (props) => (
  <CrmTagsPage {...props} />
);

export default CrmTagsApp;
